import { useState, useEffect } from 'react';
import { Input } from '@/components/ui/Input';

const groupFormatter = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });

function parseDigits(raw: string): number {
  const digits = raw.replace(/[^\d]/g, '');
  return digits === '' ? 0 : Number(digits);
}

/** Input enmascarado en formato es-CO ($ 1.234.567) que emite un number sin decimales. */
export function MoneyInput({
  value,
  onChange,
  placeholder = '$ 0',
  disabled,
}: {
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  disabled?: boolean;
}) {
  const [display, setDisplay] = useState(value ? groupFormatter.format(value) : '');

  useEffect(() => {
    setDisplay(value ? groupFormatter.format(value) : '');
  }, [value]);

  return (
    <Input
      inputMode="numeric"
      placeholder={placeholder}
      disabled={disabled}
      value={display}
      onChange={(e) => {
        const n = parseDigits(e.target.value);
        setDisplay(n ? groupFormatter.format(n) : '');
        onChange(n);
      }}
    />
  );
}
